import type {PaginationOptions} from '@hconnect/uikit/src/lib2'
import {DataTable, Column} from '@hconnect/uikit/src/lib2'
import React, {useState} from 'react'

import {useRefLinksColumns} from '../hooks'
import {RefLinks} from '../types'

type RefLinksContainerProps = {
  refLinksData: RefLinks[]
  isLoading: boolean
}

export const RefLinksContainer: React.FC<RefLinksContainerProps> = ({refLinksData, isLoading}) => {
  const [pageNumber, changePage] = useState<number>(0)
  const [itemsPerPage, setItemsPerPage] = useState<number>(10)
  const columnsTable: Column<RefLinks>[] = useRefLinksColumns()

  const data = refLinksData.slice(
    pageNumber * itemsPerPage,
    pageNumber * itemsPerPage + itemsPerPage
  )
  const onPaginationChange = (pageNumber: number, itemsPerPage: number) => {
    changePage(pageNumber)
    setItemsPerPage(itemsPerPage)
  }
  const paginationOptions: PaginationOptions = {
    onPaginationChange,
    page: pageNumber,
    rowsPerPage: itemsPerPage,
    totalDataLength: refLinksData?.length ?? 0
  }

  return (
    <DataTable<RefLinks>
      data={data}
      columns={columnsTable}
      paginationOptions={paginationOptions}
      loading={isLoading}
      data-test-id="reflinks-table"
    />
  )
}
